/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { escape } from 'lodash';
import RadioGroup from '../../components/RadioGroup/RadioGroup';
import { submitConferenceFF } from '../../utils/services';
import './FeedbackForm.scss';

class FeedbackForm extends React.PureComponent {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      fields: {
        email: {
          value: '',
          required: false
        },
        userName: {
          value: '',
          required: false
        },
        overall: {
          value: '',
          required: true
        },
        overallComment: {
          value: '',
          required: false
        },
        learnAbout: {
          value: '',
          required: true
        },
        // program: {
        //   value: '',
        //   required: true
        // },
        programBestSpeaker: {
          value: '',
          required: false
        },
        programWorstSpeaker: {
          value: '',
          required: false
        },
        streamingPlatform: {
          value: '',
          required: true
        },
        streamingComment: {
          value: '',
          required: false
        },
        // perception: {
        //   value: '',
        //   required: true
        // },
        otherComments: {
          value: '',
          required: false
        }
      },
      message: '',
      formFailed: false,
      formSubmitted: false,
      formSubmitInProgress: false
    };
  }

  onSubmit = async event => {
    event.preventDefault();
    if (this.isValidForm()) {
      this.setState({ formSubmitInProgress: true, message: '' });
      try {
        const data = {};
        Object.keys(this.state.fields).forEach(key => {
          data[key] = escape(this.state.fields[key].value);
        });
        await submitConferenceFF(data);
        this.setState({
          formSubmitInProgress: false,
          formSubmitted: true,
          formFailed: false,
          message: ''
        });
      } catch (error) {
        const resp = error.response ? error.response.data : { msg: '' };
        this.setState({ formSubmitInProgress: false, message: resp.msg, formFailed: true });
      }
    }
  };

  closeAlert = () => {
    this.setState({ formFailed: false });
  };

  isValidForm = () => {
    if (
      (this.state.fields.email.value !== '' && this.state.fields.userName.value === '') ||
      (this.state.fields.email.value === '' && this.state.fields.userName.value !== '')
    ) {
      return false;
    }

    if (
      this.state.fields.userName.value !== '' &&
      !/(.+)@(.+){2,}\.(.+){2,}/.test(this.state.fields.email.value)
    ) {
      return false;
    }

    // eslint-disable-next-line
    return Object.keys(this.state.fields).every(key =>
      this.state.fields[key].required ? this.state.fields[key].value : true
    );
  };

  updateValue = event => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      fields: {
        ...prevState.fields,
        [name]: {
          ...prevState.fields[name],
          touched: true,
          value
        }
      }
    }));
  };

  render() {
    const data = this.state.fields;
    const submitFailedMessage = this.state.formFailed ? (
      <div className="notification is-danger alert-submit-failed text-center" role="alert">
        <button
          aria-label="Close"
          className="delete"
          data-dismiss="alert"
          onClick={this.closeAlert}
          type="button">
          <span aria-hidden="true">×</span>
        </button>
        {this.state.message !== ''
          ? this.state.message
          : 'Something went wrong and your information was not stored. Please, try again.'}
      </div>
    ) : null;

    const submitSuccessMessage = this.state.formSubmitted ? (
      <div className="notification is-success text-center" role="alert">
        Feedback was successfully submitted, thank you.
      </div>
    ) : null;

    const inProgress = this.state.formSubmitInProgress ? (
      <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
    ) : null;

    const missingFieldsMessage = this.isValidForm() ? null : (
      <h3 className="text-center ff-bottom-request">
        <b className="text-danger ff-request">Please fill in all required fields (*).</b>
      </h3>
    );

    return (
      <section className="section" id="ff">
        <div className="page-header text-center ff-form">
          <h1 className="title">Feedback Form</h1>
        </div>
        {missingFieldsMessage}
        <div className="container feedback-form">
          <form className="form-horizontal" noValidate onSubmit={this.onSubmit}>
            <div className="form-group field is-horizontal columns">
              <label className="control column is-4 label" htmlFor="overall-assessment">
                Overall assessment of the conference program (presentations and speakers)
                <strong className="red-font">*</strong>
              </label>
              <div className="control field column" name="overall-assessment">
                <RadioGroup
                  dataField={data.overall.value}
                  name="overall"
                  updateValue={this.updateValue}
                />
              </div>
            </div>

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="learnAbout">
                How did you learn about the conference? <strong className="red-font">*</strong>
              </label>
              <div className="column">
                <div className="select custom-select-sm level-right is-rounded">
                  <select
                    className="custom-select"
                    name="learnAbout"
                    onChange={this.updateValue}
                    value={data.learnAbout.value}>
                    <option key="0" value="" />
                    <option key="1" value="Social media (Facebook, Twitter, ...)">
                      Social media (Facebook, Twitter, ...)
                    </option>
                    <option key="2" value="robime.it">
                      robime.it
                    </option>
                    <option key="3" value="Zive.sk">
                      Zive.sk
                    </option>
                    <option key="4" value="Nextech">
                      Nextech
                    </option>
                    <option key="5" value="Touchit.sk">
                      Touchit.sk
                    </option>
                    <option key="5" value="FonTech">
                      FonTech
                    </option>
                    <option key="6" value="Email invitation">
                      Email invitation
                    </option>
                    <option key="7" value="Recommended by friend/colleague">
                      Recommended by friend/colleague
                    </option>
                    <option key="8" value="Attended previous editions of OpenSlava">
                      Attended previous editions of OpenSlava
                    </option>
                    <option key="9" value="Accenture internal channels (employee)">
                      Accenture internal channels (employee)
                    </option>
                    <option key="10" value="Other">
                      Other
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="overall-assessment-comment">
                Additional comment about overall assessment
              </label>
              <div className="column fix-space-sm" name="overall-assessment-comment">
                <textarea
                  className="form-control textarea"
                  maxLength="1000"
                  name="overallComment"
                  onChange={this.updateValue}
                  placeholder="Your additional assessment. Maximum 1000 characters."
                  type="text"
                  value={data.overallComment.value}
                />
              </div>
            </div>

            {/* <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="overall-program">
                Overall assessment of the conference program (presentations and speakers){' '}
                <strong className="red-font">*</strong>
              </label>
              <div className="control field column" name="overall-program">
                <RadioGroup
                  dataField={data.program.value}
                  name="program"
                  updateValue={this.updateValue}
                />
              </div>
            </div> */}

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="overall-program-best">
                The best talk (pls. include reason in comment)
              </label>
              <div className="column fix-space-sm" name="overall-program-best">
                <textarea
                  className="form-control textarea"
                  maxLength="1000"
                  name="programBestSpeaker"
                  onChange={this.updateValue}
                  placeholder="Talk that was the best. Maximum 1000 characters."
                  type="text"
                  value={data.programBestSpeaker.value}
                />
              </div>
            </div>

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="overall-program-worst">
                The worst talk (pls. include reason in comment)
              </label>
              <div className="column fix-space-sm" name="overall-program-worst">
                <textarea
                  className="form-control textarea"
                  maxLength="1000"
                  name="programWorstSpeaker"
                  onChange={this.updateValue}
                  placeholder="Talk that was the worst. Maximum 1000 characters."
                  type="text"
                  value={data.programWorstSpeaker.value}
                />
              </div>
            </div>

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="streaming-platform">
                How would you assess the conference streaming platform Virtual Showfloor?{' '}
                <strong className="red-font">*</strong>
              </label>
              <div className="control field column" name="streaming-platform">
                <RadioGroup
                  dataField={data.streamingPlatform.value}
                  name="streamingPlatform"
                  updateValue={this.updateValue}
                />
              </div>
            </div>

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="streaming-platform-comment">
                Additional comment about the conference platform
              </label>
              <div className="column fix-space-sm" name="streaming-platform-comment">
                <textarea
                  className="form-control textarea"
                  maxLength="1000"
                  name="streamingComment"
                  onChange={this.updateValue}
                  placeholder="Your additional assessment. Maximum 1000 characters."
                  type="text"
                  value={data.streamingComment.value}
                />
              </div>
            </div>

            {/* <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="perception">
                How did OpenSlava 2021 influence your perception of Accenture as one of the leading
                technology companies? <strong className="red-font">*</strong>
              </label>
              <div className="control field column" name="perception">
                <div className="field is-left is-horizontal">
                  <label className="radio">
                    <input
                      checked={data.perception.value === 'In a positive way'}
                      name="perception"
                      onChange={this.updateValue}
                      type="radio"
                      value="In a positive way"
                    />{' '}
                    In a positive way
                  </label>
                </div>
                <div className="field is-left is-horizontal">
                  <label className="radio">
                    <input
                      checked={data.perception.value === 'Did not change my perception'}
                      name="perception"
                      onChange={this.updateValue}
                      type="radio"
                      value="Did not change my perception"
                    />{' '}
                    Did not change my perception
                  </label>
                </div>
                <div className="field is-left is-horizontal">
                  <label className="radio">
                    <input
                      checked={data.perception.value === 'In a negative way'}
                      name="perception"
                      onChange={this.updateValue}
                      type="radio"
                      value="In a negative way"
                    />{' '}
                    In a negative way
                  </label>
                </div>
              </div>
            </div> */}

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="other">
                Other comments
              </label>
              <div className="column fix-space-sm" name="other">
                <textarea
                  className="form-control textarea"
                  maxLength="1000"
                  name="otherComments"
                  onChange={this.updateValue}
                  placeholder="Any other ideas. Maximum 1000 characters."
                  type="text"
                  value={data.otherComments.value}
                />
              </div>
            </div>

            <hr />

            <div className="form-group columns">
              <label className="control column is-4 label" htmlFor="email">
                Submit your feedback anonymously or provide us with your contact details and have a
                chance to win Apple Watch SE from Accenture in our lottery (both fields are required
                in such case)
              </label>
              <div className="column fix-space-sm">
                <input
                  className="control input is-rounded"
                  name="email"
                  onChange={this.updateValue}
                  placeholder="Your email"
                  type="email"
                  value={data.email.value}
                />
              </div>
              <div className="column fix-space-sm">
                <input
                  className="control input is-rounded"
                  name="userName"
                  onChange={this.updateValue}
                  placeholder="Your name"
                  type="text"
                  value={data.userName.value}
                />
              </div>
            </div>

            {missingFieldsMessage}
            {submitSuccessMessage}
            {submitFailedMessage}
            {inProgress}

            <div className="submit">
              <button
                className="button is-large is-rounded btn-submit"
                disabled={
                  !this.isValidForm() || this.state.formSubmitInProgress || this.state.formSubmitted
                }
                type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  }
}

export default FeedbackForm;
